import { IsNotEmpty, Length } from 'class-validator';

export class PromoCodeFormModel {
  @Length(8, 8, { message: 'Промокод состоит из 8 символов' })
  @IsNotEmpty({ message: 'Введите промокод' })
  id: string;
}
